/*
 * @Author: libo 
 * @Date: 2020-11-13 17:26:14 
 * @Last Modified by: mayanxia
 * @Last Modified time: 2022-04-06 20:52:58
 */

<!--批量导入界面-->
<template>
    <a-modal
        :title="title"
        :width="800"
        :visible="visible"
        :confirmLoading="confirmLoading"
        :okButtonProps="{ props: {disabled: true} }"
        :maskClosable="maskClosable"
        @ok="handleOk"
        @cancel="handleCancel"
        :cancelText="$t('关闭')">
        <a-spin :spinning="confirmLoading">
            <a-row :gutter="24">
                <a-col :span="24">
                    <a-descriptions :title="$t('新固件信息')" bordered size="small">
                        <a-descriptions-item :label="$t('新固件名称')">
                            {{model.softwareNewName}}
                        </a-descriptions-item>
                        <a-descriptions-item :label="$t('新固件版本')">
                            {{model.softwareNewVersion}}
                        </a-descriptions-item>
                        <a-descriptions-item :label="$t('新固件文件')">
                            {{model.softwareNewFileName}}
                        </a-descriptions-item>
                    </a-descriptions>
                </a-col>
            </a-row>
            <a-row :gutter="24">
                <a-col :span="24">
                    <a-descriptions :title="$t('旧固件信息')" bordered size="small">
                        <a-descriptions-item :label="$t('旧固件名称')">
                            {{model.softwareOldName}}
                        </a-descriptions-item>
                        <a-descriptions-item :label="$t('旧固件版本')">
                            {{model.softwareOldVersion}}
                        </a-descriptions-item>
                        <a-descriptions-item :label="$t('旧固件文件')">
                            {{model.softwareOldFileName}}
                        </a-descriptions-item>
                    </a-descriptions>
                </a-col>
            </a-row>
            <a-row :gutter="24">
                <a-col :span="24">
                    <a-descriptions :title="$t('方案信息')" bordered size="small">
                        <a-descriptions-item :label="$t('方案名称')">
                            {{model.fotaTaskName}}
                        </a-descriptions-item>
                        <a-descriptions-item :label="$t('差分文件')">
                            {{model.fotaFileName}}
                        </a-descriptions-item>
                    </a-descriptions>
                </a-col>
            </a-row>
            <a-row :gutter="24">
                <a-card :title="$t('升级信息')">
                <detail-list :col="1">
                    <detail-list-item :term="$t('升级状态')">
                        <label :class="[model.meterFotaState === 1||model.meterFotaState === 0?'doing-status': model.meterFotaState === 3?'finish-status':'fail-status']"> {{$t(meterFotaStateObj[model.meterFotaState])}}</label>
                    </detail-list-item>
                    <detail-list-item :term="$t('升级日志')">
                        {{model.meterFotaLog}}
                    </detail-list-item>
                    <detail-list-item :term="$t('备注')">
                        {{model.remark}}
                    </detail-list-item>
                </detail-list>
                </a-card>
            </a-row>
        </a-spin>
    </a-modal>
</template>

<script>
    import DetailList from '@/components/tools/DetailList'
    const DetailListItem = DetailList.Item
    export default {
        name: 'softwareModal',
        components: {
            DetailList,
            DetailListItem
        },
        props: {
            //表单禁用
            disabled: {
                type: Boolean,
                default: false,
                required: false
            }
        },
        data () {
            const meterFotaStateObj = {0: '待升级',1: '升级中',3: '升级成功',4: '升级失败','-1': '取消升级'};
            return {
                title:this.$t("操作"),
                visible: false,
                disableSubmit:false,
                maskClosable:false,
                meterFotaStateObj,
                model: {
                    
                },
                confirmLoading: false,
            }
        },
        created () {
        
        },
        methods: {
            add() {
                this.edit({});
            },
            edit (record) { 
                this.visible = true;
                this.model = Object.assign(this.model,record)
                if(this.model.id) {
                    let newIndex = this.model.softwareNewFile.lastIndexOf('/')
                    if(newIndex>-1) {
                        this.model.softwareNewFileName = this.model.softwareNewFile.substr(newIndex+1)
                    }
                    let oldIndex = this.model.softwareOldFile.lastIndexOf('/')
                    if(oldIndex>-1) {
                        this.model.softwareOldFileName = this.model.softwareOldFile.substr(oldIndex+1)
                    }
                    let fotaIndex = this.model.fotaFilePath.lastIndexOf('/')
                    if(fotaIndex>-1) {
                        this.model.fotaFileName = this.model.fotaFilePath.substr(fotaIndex+1)
                    }
                }
                
            },
            
            handleOk(){},
            close () {
                this.$emit('close');
                this.model = this.$options.data.call(this).model
                this.disableSubmit = false;
                this.visible = false;
            },

            handleCancel () {
                this.close();
            }
        }
    }
</script>
<style scoped>
    .ant-form-item >>> .ant-select{
    width: 100%;
    }
    .span {
    margin: 8px;
    }
    .background{
    background-color:rgb(238,238,238)
    }
    .detail-list >>> .content{
    line-height: normal;
    }
</style>